import * as CSSO from "../../../shared/types/csso.types";
import { createId } from "./shared";
import * as Constants from "./constants";
import faker from "faker";

/**
 * createNotification
 * @param {string} projectId
 * @param {string} packageId
 * @return {*}  {CSSO.Notification}
 */
const createNotification = (): CSSO.Notification => {
  return {
    id: createId(),
    type: "Some Notification Type",
    description: faker.commerce.productDescription(),
    address: faker.address.streetAddress(),
    city:
      faker.datatype.number({ min: 0, max: 100 }) / 100.0 > 0.25
        ? faker.address.city()
        : null,
    county:
      faker.datatype.number({ min: 0, max: 100 }) / 100.0 > 0.25
        ? faker.address.county()
        : null,
    status: {
      id: createId(),
      name: faker.random.arrayElement(Constants.stateNames),
    },
  };
};

/**
 * getMockNotifications
 * @param {number} numberOfNotifications
 * @return {*}  {Array<CSSO.Notification>}
 */
const getMockNotifications = (
  numberOfNotifications: number
): CSSO.Notification[] => {
  const notifications: CSSO.Notification[] = [];
  while (notifications.length < numberOfNotifications) {
    const notif = createNotification();
    let skip = false;
    /* istanbul ignore next */
    for (const existing of notifications) {
      if (existing.id === notif.id) {
        skip = true;
        break;
      }
    }
    /* istanbul ignore next */
    if (!skip) {
      notifications.push(notif);
    }
  }

  return notifications;
};

export default {
  createNotification,
  getMockNotifications,
};
